import axiosRequest from "../universal/axiosService";
import { ENDPOINTS } from "../../apiConfig";


export const fetchAllApplicantsApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.RECRUITEMENT.GET_ALL,
    params: {
      ...params,

    },
  });
};

export const getApplicant = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATES.GET,
    params: {
      ...params, 
    },
    extret: "uiid fistName",
  });
};

export const updateApplicant = async (params) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.CANDIDATES.UPDATE}?uploadType=single&field=doc&coll=${params.coll}&uiid=${params.uiid}`,
    data: params.data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const addApplicant = async (formData) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.CANDIDATES.ADD}?uploadType=single&field=doc`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};


export const fetchNoteApi = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATES.GET_ALL,
    params: {
      ...params,

    },
  });
};
// {{ATS_ats_domain}}/candidates/getAll?coll=Candidate&lim=10&pg=1&ret=uiid&ref=Note

export const resumeParser = async (formData) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.CANDIDATES.RESUME_PARSER}?uploadType=single&field=doc`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const bulkResumeParser = async (formData) => {
  return await axiosRequest({
    method: "POST",
    url: `${ENDPOINTS.CANDIDATES.BULK_RESUME_PARSER}?uploadType=multiple&field=doc`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const profileOverrite = async (params, formData) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.CANDIDATES.UPDATE}?uploadType=single&field=doc&coll=${params.coll}&uiid=${params.uiid}`,
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const profileMerge = async (params, formData) => {
  return await axiosRequest({
    method: "PATCH",
    url: `${ENDPOINTS.CANDIDATES.UPDATE}?uploadType=single&field=doc&coll=${params.coll}&uiid=${params.uiid}`, 
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export const getApplicants = async (params) => {
  return await axiosRequest({
    method: "GET",
    url: ENDPOINTS.CANDIDATES.GET_ALL,
    params: {
      ...params, 
    },
    extret: "uiid fistName email",
  });
};